// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Components
import Block from "components/layout/Block";
import { ButtonDropdownSelector } from "components/layout/Button/ButtonDropdownSelector";
import { StyledDropdownButtonIcon } from "./DropdownButtonIcon.styled";

// ** SVG Static Imports
import { ReactComponent as SolidTh } from "resources/icons/solid/th-solid.svg";
import { ReactComponent as SolidSquare } from "resources/icons/solid/square-solid.svg";
import { LISTING_TYPE } from "helpers/constants";

// #####################################################

const GalleryViewTypeSelectorButton = ({
	triggerProps,
	toggle,
	isOpen,
	viewType,
	layerSide,
}) => {
	const { t } = useTranslation(["pages"]);

	// #####################################################

	return (
		<div {...triggerProps}>
			<ButtonDropdownSelector
				onClick={() => {
					if (typeof toggle === "function") {
						toggle();
					}
				}}
				isOpen={isOpen}
				aria-haspopup="true"
				label={t("pages:search")}
				layerSide={layerSide}
				dropdown
			>
				<Block flex withColumnGap>
					{viewType !== LISTING_TYPE.LIST ? (
						<StyledDropdownButtonIcon
							type="fas"
							svgIconComponent={SolidTh}
							icon="th-solid"
						/>
					) : (
						<StyledDropdownButtonIcon
							type="fas"
							svgIconComponent={SolidSquare}
							icon="square-solid"
						/>
					)}
				</Block>
			</ButtonDropdownSelector>
		</div>
	);
};

export default GalleryViewTypeSelectorButton;
